import apiClient from "./apiClient";

export async function getMeetingPrepResponse(companyId, meetingDate) {
  const r = await apiClient.get(`/api/meeting-prep/${companyId}`, { params: { meeting: meetingDate } });
  return r.data;
}

export async function getMeetingPrepQuestions(companyId) {
  const r = await apiClient.get(`/api/meeting-prep/${companyId}/questions`);
  return r.data;
}

export async function saveMeetingPrepQuestions(companyId, questions) {
  const r = await apiClient.put(`/api/meeting-prep/${companyId}/questions`, { questions });
  return r.data;
}

export async function getMeetingPrepLink(companyId, meetingDate) {
  const r = await apiClient.get(`/api/meeting-prep/${companyId}/link`, { params: { meeting: meetingDate } });
  return r.data;
}

export async function sendMeetingPrepLink(companyId, { meetingDate, contactEmail, contactName, meetingTitle }) {
  const r = await apiClient.post(`/api/meeting-prep/${companyId}/send-link`, {
    meetingDate, contactEmail, contactName, meetingTitle
  });
  return r.data;
}
